module.exports = __webpack_public_path__ + "img/wave-2.bfeb3ab1.svg";